import { render, staticRenderFns } from "./QuizUnApproved.vue?vue&type=template&id=26f11dd0&scoped=true"
import script from "./QuizUnApproved.vue?vue&type=script&lang=js"
export * from "./QuizUnApproved.vue?vue&type=script&lang=js"
import style0 from "./QuizUnApproved.vue?vue&type=style&index=0&id=26f11dd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f11dd0",
  null
  
)

export default component.exports